/* eslint-disable react/prop-types */
import React from 'react';

import Spinner from '@qality/common-components/src/atoms/atlaskit/Spinner';

import { LoadingStyled, LoadingTextStyled } from './SpinnerLoader.styled';

export const SpinnerLoaderView = ({ size, text, shouldHideContent }) => (
  <LoadingStyled shouldHideContent={shouldHideContent}>
    <Spinner size={size} />
    {text && <LoadingTextStyled>{text}</LoadingTextStyled>}
  </LoadingStyled>
);
